import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import ihmBusinessSchoolLogo from "@/assets/ihm-business-school-logo.png";

const AIForLeaders = () => {
  const { t } = useTranslation();

  return (
    <Section
      title={<>{t("aiForLeaders.titlePre")} <span className="text-gradient-brand">{t("aiForLeaders.titleAccent")}</span></>}
      titleAs="h1"
    >
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="space-y-6">
          <p className="text-muted-foreground text-lg leading-relaxed">
            {t("aiForLeaders.description")}
          </p>

          <a href="https://www.ihm.se/utbildningar/management/ai-for-ledare/" target="_blank" rel="noopener noreferrer">
            <Button variant="secondary" size="lg" className="mt-2">
              {t("aiForLeaders.readMore")}
            </Button>
          </a>
        </div>

        <div className="flex items-center justify-center">
          <div className="relative rounded-2xl border border-border/60 bg-card/60 backdrop-blur-sm p-10 w-full max-w-md">
            <img
              src={ihmBusinessSchoolLogo}
              alt={t("aiForLeaders.logoAlt")}
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default AIForLeaders;
